import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { saveCookieConsent, getDefaultPreferences } from "../../../Lib/Utils/CookieConsentUtils";

export class AcceptNecessaryCookiesAction extends BaseAction<void, void> {
  override async run(): Promise<void> {
    try {
      const necessaryOnlyPreferences = getDefaultPreferences();

      saveCookieConsent(necessaryOnlyPreferences);
      updateRecoilState('cookieConsentGivenAtom', true);
      updateRecoilState('cookiePreferencesAtom', necessaryOnlyPreferences);
      updateRecoilState('cookieConsentBannerVisibleAtom', false);
      updateRecoilState('cookieManagementModalVisibleAtom', false);
    } catch (error) {
      console.error("Error in AcceptNecessaryCookiesAction:", error);
    }
  }
} 